<div class="flex h-full bg-slate-50 font-sans text-slate-700">

    <aside class="w-1/4 max-w-sm bg-white border-r border-slate-200 overflow-y-auto p-8">
        <div class="mb-10">
            <!-- <button
                class="flex items-center text-sm font-semibold text-slate-500 hover:text-blue-600 transition-colors">
                <span class="mr-2">←</span> Torna alle Aree
            </button> -->
            <h1 class="text-2xl font-bold mt-4 text-slate-800">{{viewConfig.viewName}}</h1>
            <p class="text-sm text-slate-400">{{viewConfig.viewDescription}}</p>
        </div>

        <nav class="relative">
            <div class="absolute left-[15px] top-0 bottom-0 w-0.5 bg-slate-100 -z-0"></div>

            <div *ngFor="let step of viewConfig.viewFields; let i = index"
                class="relative z-10 flex items-start mb-10 group cursor-pointer" (click)="goToStep(i)">

                <div [ngClass]="{
                    'bg-slate-800 text-red-400 border-slate-800': activeStepIndex === i,
                    'bg-white text-slate-400 border-slate-300': activeStepIndex !== i && !baseData[scope][id][viewConfig.viewFields[i].columnCode],
                    'bg-slate-700 text-red-400 border-slate-700': activeStepIndex !== i && !!baseData[scope][id][viewConfig.viewFields[i].columnCode]
                    }" 
                    class="flex-shrink-0 w-8 h-8 rounded-full border-2 flex items-center justify-center text-xs font-bold transition-all">
                    <span *ngIf="!baseData[scope][id][viewConfig.viewFields[i].columnCode]">{{ i + 1 }}</span>
                    <span *ngIf="!!baseData[scope][id][viewConfig.viewFields[i].columnCode]">✓</span>
                </div>
                <div class="ml-4">
                    <h3 [ngClass]="activeStepIndex === i ? 'text-slate-900 font-bold' : 'text-slate-500 font-medium'"
                        class="text-sm leading-tight">
                        {{ step.header }}
                    </h3>
                    <p class="text-xs text-slate-400 mt-1 leading-snug">
                        {{ step.notes || 'Descrizione dello step...' }}
                    </p>
                </div>
            </div>
        </nav>
    </aside>

    <main class="flex-1 flex flex-col items-center justify-center p-12">

        <div
            class="w-full max-w-2xl bg-white rounded-3xl shadow-sm border border-slate-100 p-12 min-h-[400px] flex flex-col">

            <div class="mb-8">
                <h2 class="text-xl font-bold text-slate-800 mb-2">
                    {{ currentField.fieldDescription }}
                </h2>
            </div>

            <div class="flex-1">
                <app-drake-field [fieldConfig]="currentField"
                    (valueChanged)="valueChanged($event)" [baseData]="baseData[scope][id]" [readonly]="readonly"
                    [mode]="'DEFAULT'">
                </app-drake-field>
            </div>

            <div class="mt-12 flex justify-center">
                <div class="inline-flex items-center bg-blue-50/50 p-2 rounded-full border border-blue-100">
                    <button (click)="prevStep()" [disabled]="activeStepIndex === 0"
                        class="flex items-center px-6 py-2 rounded-full font-semibold text-blue-700 hover:bg-white transition-all disabled:opacity-30">
                        <span class="mr-2">←</span> Precedente
                    </button>

                    <span class="mx-6 text-sm font-bold text-blue-900/40">
                        {{ activeStepIndex + 1 }} / {{ viewConfig.viewFields.length }}
                    </span>

                    <button (click)="nextStep()" [disabled]="activeStepIndex === viewConfig.viewFields.length - 1"
                        class="flex items-center px-6 py-2 rounded-full font-semibold text-blue-700 hover:bg-white transition-all disabled:opacity-30">
                        Successiva <span class="ml-2">→</span>
                    </button>
                </div>
            </div>

        </div>
    </main>

</div>